import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

/** Matches Court Cases v2 `DisclaimerBox` (FaqSection) — neutral notice panel. */
export const DisclaimerContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: '12px',
  border: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(3),
  },
}));

export const DisclaimerHeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const DisclaimerIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  flexShrink: 0,
  marginTop: 1,
  '& .MuiSvgIcon-root': {
    fontSize: 18,
  },
}));

export const DisclaimerText = styled(Text)(({ theme }) => ({
  fontSize: 14,
  lineHeight: '22px',
  fontStyle: 'normal',
  fontWeight: 400,
  color: theme.palette.text.secondary,
}));
